<script setup lang="ts">
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();
</script>

<template>
   <MediaSelector
      v-model="model.video.url"
      v-model:media-id="model.video_id"
      :type="'video'"
      :error="props.errors['video_id']"
      :show-videos="true"
      :show-images="false"
   />
</template>
